export type Config = {
  apiUrl: string;
  agGridKey: string;
};

export const cfg: Config = {
  apiUrl: import.meta.env.VITE_API_URL!,
  agGridKey: import.meta.env.VITE_AG_GRID_LICENSE_KEY!,
};
